import React from 'react';

export default ({
  text,
  selected,
  enabled,
  addMode,
  onAdd,
  onClick,
  onToggle,
}) => {
  const selectedClassName = selected ? 'selected' : '';
  const enabledClassName = enabled ? 'enabled' : '';
  const meaningText = text || "This word doesn't have a meaning";
  return (
    <div
      onClick={onClick}
      className={`synonym-list-meaning ${selectedClassName}`}
    >
      <p className="synonym-list-meaning-text">{meaningText}</p>
      {addMode ? null : (
        <div
          onClick={e => onToggle(!enabled)}
          className={`synonym-list-checkbox-wrapper ${enabledClassName}`}
        >
          <div className="checkbox" />
          <label> Enable </label>
        </div>
      )}
    </div>
  );
};
